<ion-progress-bar [value]="statusInfo?.progress" [buffer]="1 - statusInfo?.progress"></ion-progress-bar>